import PageLayout from '@/components/feature/PageLayout';
import { useSeo } from '@/hooks/useSeo';
import { useJsonLd } from '@/hooks/useJsonLd';
import Hero from './components/Hero';
import CategoryStrip from './components/CategoryStrip';
import FeaturedCharacters from './components/FeaturedCharacters';
import RankingSection from './components/RankingSection';
import WorksSection from './components/WorksSection';
import SeiyuuSection from './components/SeiyuuSection';
import FaqSection from './components/FaqSection';
import { Link } from 'react-router-dom';

export default function Home() {
  useSeo({
    title: '妖精动漫网 - 妖精动漫角色百科与声优表专题',
    description: '妖精动漫网专注妖精、精灵类动漫作品的角色百科与声优表。收录森林精灵、花之妖精、星之精灵等动漫人物介绍、角色人气榜与详细配音演员信息，资料集中、查找高效。',
  });

  useJsonLd([
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '妖精动漫网',
      description: '妖精动漫角色百科与声优表专题网站',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: '妖精动漫人气角色榜',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '琳娅·夜莺' },
        { '@type': 'ListItem', position: 2, name: '芙洛拉·蔷薇' },
        { '@type': 'ListItem', position: 3, name: '艾露·星语' },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        { '@type': 'Question', name: '如何快速查找某位角色的配音演员？', acceptedAnswer: { '@type': 'Answer', text: '可前往声优表页面按角色或作品名检索，或在角色详情页查看出演信息栏对应的声优与代表作。' } },
        { '@type': 'Question', name: '角色人气榜是如何产生的？', acceptedAnswer: { '@type': 'Answer', text: '根据用户收藏、浏览热度与社区评分综合计算，每周更新，在首页与角色百科页展示前 10 名。' } },
      ],
    },
  ]);

  return (
    <PageLayout>
      <Hero />
      <CategoryStrip />
      <FeaturedCharacters />
      <RankingSection />
      <WorksSection />
      <SeiyuuSection />

      {/* 关于 / CTA 横幅 */}
      <section className="relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20artistic%20fantasy%20forest%20banner%20with%20floating%20golden%20leaves%20and%20emerald%20glow%20particles%2C%20warm%20moody%20backdrop%2C%20abstract%20magical%20atmosphere%2C%20deep%20green%20and%20gold%20gradient&width=1600&height=500&seq=cta-about&orientation=landscape"
          alt="森林与星光交织的奇幻氛围背景"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/80 to-primary-900/90" />
        <div className="relative z-10 mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-20 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">一座属于妖精与精灵爱好者的资料馆</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-7 text-background-100/90">
            妖精动漫网持续整理妖精、精灵类动漫的角色百科与声优表，帮助每一位爱好者快速查角色、看作品、找声优。资料集中，查找高效，欢迎随时查阅与共建。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3 text-sm font-medium text-primary-900 whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/characters"
              className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-full border border-background-50/40 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-background-50/10 transition-colors"
            >
              浏览角色百科
            </Link>
          </div>
        </div>
      </section>

      <FaqSection />
    </PageLayout>
  );
}